import {
  mobileAccordions,
  resetSecondaryMenu,
  navScroll,
  switchContent,
} from "../utilities/nav-utils"

import { closeAllToggletips } from "../utilities/toggletip-engine"

class NavigationMain extends HTMLElement {
  connectedCallback() {
    this.headerEl = document.getElementById("nav-wrapper")
    this.navigationItems = this.querySelectorAll("toggletip-engine")
    this.cartOpenButtons = this.querySelectorAll("button[name='cart-open']")
    this.cartDrawer = document.querySelector("drawer-component")

    this.ux = this.dataset.ux
    this.uxPosition = this.dataset.uxPosition

    this.headerEl.props = {}
    this.headerEl.props.navMargin = 0
    this.headerEl.props.transformAmount = 0
    this.headerEl.props.lastScroll = window.scrollY
    this.headerEl.props.submenuOpen = false
    this.headerEl.props.activeMenu = 0

    this.resetHeader()

    if (this.uxPosition === "off" || this.uxPosition === "hide") {
      this.observeStickySubheader()
    }

    if (this.uxPosition !== "off") {
      window.addEventListener("scroll", this.handleScroll)
    }

    this.resetOnResize()
    this.handleCartDrawer()

    this.enableNavUX()
  }

  // resets the header to default by removing navScroll utility changes
  resetHeader = () => {
    this.headerEl.classList.remove("header-visible")
    this.headerEl.classList.remove("sticky-active")
    this.headerEl.classList.remove("reached-top")
    this.headerEl.style.marginTop = ""
    document.getElementById("header-spacer").style.paddingTop = ""
  }

  handleScroll = () => {
    navScroll(this.headerEl, this.uxPosition)
  }

  enableNavUX() {
    if (this.uxPosition === "fixed") {
      this.headerEl.classList.add("sticky")
    } else {
      this.headerEl.classList.remove("sticky")
    }

    if (this.ux === "click") {
      this.navigationItems.forEach((navigationMenuItem) => {
        navigationMenuItem.addEventListener("click", (e) => {
          e.stopPropagation()

          if (navigationMenuItem.isOpen) {
            closeAllToggletips(false)
          } else {
            closeAllToggletips(true, navigationMenuItem)
            navigationMenuItem.open()
          }
        })
      })

      this.closest(".shopify-section").addEventListener("click", () => {
        closeAllToggletips()
      })
    } else {
      this.navigationItems.forEach((navigationMenuItem) => {
        const isSearchTrigger = navigationMenuItem.querySelector('.search-trigger')
        const isMenuTrigger = navigationMenuItem.querySelector('.menu-trigger')

        if (isSearchTrigger || isMenuTrigger) {
          // Add click behavior for search/menu triggers
          navigationMenuItem.addEventListener("click", (e) => {
            e.stopPropagation()
            if (navigationMenuItem.isOpen) {
              closeAllToggletips(false)
            } else {
              closeAllToggletips(true, navigationMenuItem)
              navigationMenuItem.open()
            }
          })
        } else {
          // Add hover behavior for navigation items
          navigationMenuItem.addEventListener("mouseenter", () => {
            closeAllToggletips(true, navigationMenuItem)
            navigationMenuItem.open()
          })

          navigationMenuItem.addEventListener("mouseleave", () => {
            navigationMenuItem.close()
          })

          // Add event listeners for the dropdown
          const dropdown = navigationMenuItem.querySelector("[data-tooltip]")
          if (dropdown && navigationMenuItem.handleDropdownEnter && navigationMenuItem.handleDropdownLeave) {
            dropdown.addEventListener("mouseenter", () => {
              navigationMenuItem.handleDropdownEnter()
            })
            dropdown.addEventListener("mouseleave", () => {
              navigationMenuItem.handleDropdownLeave()
            })
          }
        }
      })
    }

    this.querySelectorAll(".nav").forEach((nav) => {
      resetSecondaryMenu(nav)
    })

    this.querySelectorAll(".nav").forEach((el) => {
      el.props = {}

      // Get the first menu link and its content
      const firstButton = el.querySelector(".nav__main-menu-link")
      const firstContent = firstButton?.parentNode.querySelector(".nav__secondary-menu__item")
      const navContent = this.querySelector(".nav--multilevel .nav__content")

      if (firstContent && navContent) {
        const contentHeight = firstContent.getBoundingClientRect().height
        navContent.style.height = contentHeight + "px"
      }

      el.querySelectorAll(".nav__main-menu-link").forEach((button, index) => {
        if (window.matchMedia("(hover: hover)").matches) {
          if (window.matchMedia("(min-width: 1024px)").matches) {
            button.addEventListener("mouseover", () => {
              switchContent(button, el)
            })
          }
        }

        button.addEventListener("focus", () => {
          switchContent(button, el)
        })

        button.addEventListener("click", () => {
          el.classList.add("nav--secondary-menu-open")
          switchContent(button, el)

          const targetMenu = button.getAttribute("data-targetmenu")
          const nextContent = el.querySelector(`#${targetMenu}`)
          const innerContainer = el.querySelector(".nav--mobile__inner-container")

          if (el.classList.contains("nav--mobile")) {
            el.querySelector(".container").scrollTop = 0
          }
        })
      })

      el.querySelectorAll(".nav__secondary-menu__close").forEach((button) => {
        button.addEventListener("click", () => {
          resetSecondaryMenu(el)
        })
      })

      // mobile accordion
      mobileAccordions(el, true)
    })
  }

  observeStickySubheader() {
    const stickySubheader = document.querySelector(".sticky-subheader")
    if (!stickySubheader) return

    stickySubheader.props = { isStuck: false }

    const observer = new IntersectionObserver(
      ([e]) => {
        const isStuck = e.intersectionRatio < 1
        e.target.classList.toggle("sticky--stuck", isStuck)

        const shouldUpdate = e.target.props.isStuck !== isStuck

        if (shouldUpdate) e.target.props.isStuck = isStuck
      },
      { threshold: [1] },
    )

    observer.observe(stickySubheader)
  }

  // reset stuff when resizing from desktop to mobile
  resetOnResize() {
    const mobileMedia = window.matchMedia("(max-width: 1024px)")
    mobileMedia.addEventListener("change", () => {
      closeAllToggletips()

      if (mobileMedia.matches) {
        // should reset desktop related stuff
        this.headerEl.style.marginTop = 0
        this.headerEl.props.navMargin = 0
      }
    })
  }

  handleCartDrawer() {
    if (this.cartOpenButtons) {
      this.cartOpenButtons.forEach((button) => {
        button.addEventListener("click", () => {
          closeAllToggletips(true)

          this.cartDrawer.open()
        })
      })
    }
  }

  disconnectedCallback() {
    if (this.uxPosition !== "off") {
      window.removeEventListener("scroll", this.handleScroll)
    }
  }
}

if (!window.customElements.get("main-nav")) {
  window.customElements.define("main-nav", NavigationMain)
}
